// extracted by mini-css-extract-plugin
module.exports = {"course-list-header":"course-list_course-list-header__oXqRd","course-directory-wrapper":"course-list_course-directory-wrapper__DQ9OT"};